import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import AddrSearch from 'components/common/AddrSearch/AddrSearch';
import { notification, Table, Modal, Tooltip, Button, Input, Radio, Descriptions } from 'antd';
import jquery from 'jquery';
import $ from 'jquery';   
import axios from 'axios';


@inject(({ orderStore }) => ({ 
  lastOrder: orderStore.lastOrder,
  disLastOrder: orderStore.disLastOrder,
  addOrderList: orderStore.addOrderList,
  onChangValue: orderStore.onChangValue,
  tempOrCartNo: orderStore.tempOrCartNo,
  testKcp: orderStore.testKcp,
}))

@observer
class OrderModalNoUser extends Component {
  state = {
    modalOpenAddr: false,
    orAddr: '',
    orAddrDetail: '',
    orZipCd: '',
    mgrUserId: '',
    mgrHp: '',
    payment: '', //추가
    good_name: "",    //상품명
    ordr_idxx :  "",
    dbmoney : "",
    // tempOrCartNo: "",     // 임시 주문리스트 주문번호
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalOpen !== this.props.modalOpen) {
      if (nextProps.modalOpen === true) {
        this.props.disLastOrder();
      }
    }

    if (nextProps.lastOrder !== this.props.lastOrder) {
      if (nextProps.modalOpen === true) {
        this.setState({
          orAddr: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.orAddr !== undefined && nextProps.lastOrder.orAddr !== null) ? nextProps.lastOrder.orAddr : '',
          orAddrDetail: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.orAddrDetail !== undefined && nextProps.lastOrder.orAddrDetail !== null) ? nextProps.lastOrder.orAddrDetail : '',
          orZipCd: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.orZipCd !== undefined && nextProps.lastOrder.orZipCd !== null) ? nextProps.lastOrder.orZipCd : '',
          mgrUserId: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.mgrUserId !== undefined && nextProps.lastOrder.mgrUserId !== null) ? nextProps.lastOrder.mgrUserId : '',
          mgrHp: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.mgrHp !== undefined && nextProps.lastOrder.mgrHp !== null) ? nextProps.lastOrder.mgrHp : '',
           //추가
           payment: (nextProps.lastOrder !== null && 
            nextProps.lastOrder.payment !== undefined && nextProps.lastOrder.payment !== null) ? nextProps.lastOrder.payment : '',
            //추가
            good_name: (nextProps.lastOrder !== null && 
             nextProps.lastOrder.good_name !== undefined && nextProps.lastOrder.good_name !== null) ? nextProps.lastOrder.good_name : '',                                  
        });
      }
    }
  }

  render() {
    const radioTemp={
      color: "#ff0000"
    }
    const { modalOpenAddr, orZipCd, orAddr, orAddrDetail, mgrUserId, mgrHp, payment, good_name,order_total , ordr_idxx ,  deliveryPrice} = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM', width: 70, align: 'center' },
      { title: '센터', dataIndex: 'caUserId', width: 180, align: 'center' },
      // { title: '담당자', dataIndex: 'userNm', width: 150, align: 'center' },
      { title: '상품명', dataIndex: 'gdNm', width: 250, align: 'center' },
      { title: '사이즈', dataIndex: 'caGdSize', width: 150, align: 'center',
        render: (item, record, index) => { return(
          item === "기타"
          ? <Tooltip placement="topLeft" title={record.caEtc}>
              <span style={{color: 'blue'}}>{item}</span>
            </Tooltip>
          : item
        )}
      },
      { title: '주문수량', dataIndex: 'caCnt', width: 100, align: 'center' },
      { title: '금액', dataIndex: 'gdPrice', width: 130, align: 'center',
        render: (item, record) => { return(
          <Fragment>
            {item !== undefined && item !== null && item !== '' &&
            (parseInt(item)*parseInt(record.caCnt)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </Fragment>
        )}
      },
      // { title: '신청사유', dataIndex: 'reqReason', width: 130, align: 'center',
      //   render: (item, record, index) => { 
      //     return (
      //       item !== undefined && item !== null && item !== "" &&
      //       <Tooltip placement="topLeft" title={record.reqReason}>
      //         <span style={{color: 'blue'}}>신청사유</span>
      //       </Tooltip>
      //     )
      //   },
      // },
    ];

    window.addEventListener('message', function(e) {    
      if(e.data.childData === 'please reload'){
        this.window.location.reload();
      }
    });
    const handleKcp = () =>{
      let ordr_idxx ="";
      this.props.cartList.map(item=>{return(       
        ordr_idxx = item.orCardNo
      )});      
      this.state.ordr_idxx = ordr_idxx;
    }
    const handleGoodname = () =>{
      let good_name = "";
      this.props.cartList.map(item=>{return(       
        good_name = item.gdNm
      )});         
      this.state.good_name = good_name;

    }     
    const totalMoney = () => {
      let total = 0;
      let caCnt = 0;

      this.props.cartList.map(item=>{return(       
        caCnt = caCnt + parseInt(item.caCnt)
      )});        
      this.props.cartList.map(item=>{return(
        total = total + parseInt(item.gdPrice)*parseInt(item.caCnt)
      )});
      this.state.order_total=total;
      if(caCnt < 11){
        total = total+3600;
        this.state.order_total=total;
        this.state.deliveryPrice = 3600;
      }
      handleKcp();
      handleGoodname();         
      return (
        <Fragment>{total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Fragment>
      );
    };

    // 장바구니 DB조회하는 함수 ( 장바구니 db조회 금액 : dbmoney / 화면에 보이는 금액 : orMony ) - 결제할때 금액이 달라도 결제가 되는 현상 해결하기 위해
    const checkMoney = async() =>{
      let dbmoney;
      var orMony = this.state.order_total;
      let orCartNo = this.props.tempOrCartNo;
//      console.log("orCartNo!@!@!@ (checkMoney) ::::: ", orCartNo);
      const params = new URLSearchParams();
      params.append('orCartNo', orCartNo);
      try {
        axios
          // .post("http://localhost:80/order/DIS-CHECK-MONEY")
          // .post("http://www.yujinmalls.co.kr/order/DIS-CHECK-MONEY")
          .post(`${process.env.REACT_APP_URL}/order/DIS-CHECK-MONEY`)
          .then(function (response) {
            dbmoney = response.data;
            if (dbmoney === 'ALREADY_PAID') { // 주문번호로 KCP_PAY_RES 테이블 조회시, 이미 주문완료된 건이 있을경우!!
              alert('이미 결제가 완료된 주문입니다.');
              return;
            }
            if(orMony !== dbmoney){   // 디비 머니랑 현재 주문하기 모달의 머니가 일치 하지 않는다면 => 곧 누군가 동시접속해서 카트리스트를 수정하고 있다면!!! 
              alert('새로고침(F8) 후 재시도 해주세요.');
            }else{
              kcpWindow();
              // test();    // 결제 이후 테스트 위함
              console.log("dbmoney : "+dbmoney); // 장바구니 db조회 금액
              console.log("orMony : "+orMony);   // 화면에 보이는 금액
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } catch (e) {
        console.error(e);
      }
    }

    // 주문하기 버튼 눌렀을 때 호출 함수
    const onClick = () =>{
      checkMoney();
    }

    // kcp결제 창 호출 함수
    const kcpWindow = () =>{
    // console.log('kcp before tempOrCartNo : ', this.props.tempOrCartNo);
    window.open("", "_order", "toolbar=no,scrollbars=no,resizable=yes,top=50,left=500,width=760,height=570");

     var newForm = document.createElement('form');
     // set attribute (form) 
     newForm.name = 'newForm';
     newForm.method = 'post';
     // newForm.action = 'http://localhost:80/order/order';
     // newForm.action = 'http://www.yujinmalls.co.kr/order/order';
     newForm.action = `${process.env.REACT_APP_URL}/order/order`;
     newForm.target = '_order';

     // 주문번호 하드코딩 임시
     var ordr_idxx = this.state.ordr_idxx;

     var input1 = document.createElement('input');
     input1.setAttribute("type", "hidden");
     input1.setAttribute("name", "ordr_idxx");
     input1.setAttribute("value", ordr_idxx);
     newForm.appendChild(input1);

     // 상품명
     var gdn = this.state.good_name;
     var input2 = document.createElement('input');
     // set attribute (input)
     input2.setAttribute("type", "hidden");
     input2.setAttribute("name", "good_name");
     input2.setAttribute("value", gdn);
     // append input (to form)
     newForm.appendChild(input2);

     //상품금액
     //총금액
     var money = this.state.order_total;
     //console.log(money);
     var input3 = document.createElement('input');
     input3.setAttribute("type", "hidden");
     input3.setAttribute("name", "good_mny");
     input3.setAttribute("value", money);
     newForm.appendChild(input3);

     // 주문자명 대처
     var input4 = document.createElement('input');
     // set attribute (input)
     input4.setAttribute("type", "hidden");
     input4.setAttribute("name", "shop_user_id");
     input4.setAttribute("value", 'yujinL');
     // append input (to form)
     newForm.appendChild(input4);

     // 결제타입
    //  console.log(this.state.payment);
     var input5 = document.createElement('input');
     // set attribute (input)
     input5.setAttribute("type", "hidden");
     input5.setAttribute("name", "pay_method");
     input5.setAttribute("value", this.state.payment);
     // append input (to form)
     newForm.appendChild(input5);

     // 사이트시디
     var input6 = document.createElement('input');
     // set attribute (input)
     input6.setAttribute("type", "hidden");
     input6.setAttribute("name", "site_cd");
    //  input6.setAttribute("value", 'T0000');
     input6.setAttribute("value", 'WH034');
     // append input (to form)
     newForm.appendChild(input6);

     // 주문상태값
     var input7 = document.createElement('input');
     // set attribute (input)
     input7.setAttribute("type", "hidden");
     input7.setAttribute("name", "or_stat");
     input7.setAttribute("value", '2');
     // append input (to form)
     newForm.appendChild(input7);
     
     // 주소
     var input12 = document.createElement('input');
     // set attribute (input)
     input12.setAttribute("type", "hidden");
     input12.setAttribute("name", "orAddr");
     input12.setAttribute("value", this.state.orAddr);
     // append input (to form)
     newForm.appendChild(input12);
     
     // 상세주소
     var input8 = document.createElement('input');
     // set attribute (input)
     input8.setAttribute("type", "hidden");
     input8.setAttribute("name", "orAddrDetail");
     input8.setAttribute("value", this.state.orAddrDetail);
     // append input (to form)
     newForm.appendChild(input8);
 
     // 우편번호
     var input9 = document.createElement('input');
     // set attribute (input)
     input9.setAttribute("type", "hidden");
     input9.setAttribute("name", "orZipCd");
     input9.setAttribute("value", this.state.orZipCd);
     // append input (to form)
     newForm.appendChild(input9);
     
     // 인수자아이디
     var input10 = document.createElement('input');
     // set attribute (input)
     input10.setAttribute("type", "hidden");
     input10.setAttribute("name", "mgrUserId");
     input10.setAttribute("value", this.state.mgrUserId);
     // append input (to form)
     newForm.appendChild(input10);     

     // 인수자휴대폰폰
     var input11 = document.createElement('input');
     // set attribute (input)
     input11.setAttribute("type", "hidden");
     input11.setAttribute("name", "mgrHp");
     input11.setAttribute("value", this.state.mgrHp);
     // append input (to form)
     newForm.appendChild(input11);   

     //배송비 
     var fee =   this.state.deliveryPrice;
     //console.log(fee);
     var input13 = document.createElement('input');
     input13.setAttribute("type", "hidden");
     input13.setAttribute("name", "deliveryPrice");
     input13.setAttribute("value", fee);
     newForm.appendChild(input13);

     // 임시 주문리스트 주문번호
     var input14 = document.createElement('input');
     input14.setAttribute("type", "hidden");
     input14.setAttribute("name", "tempOrCartNo");
     input14.setAttribute("value", this.props.tempOrCartNo);
     newForm.appendChild(input14);

//     console.log("this.props.tempOrCartNo!@!@!@", this.props.tempOrCartNo);
     
     // append form (to body)
     document.body.appendChild(newForm);    

     // submit form
     newForm.submit();
     $("#newForm").remove();

    }    

    // 결제 이후 테스트 위함
    const test = () => {
      console.log('테스트 버튼 클릭');
      this.props.testKcp();
    }

    return (
       
      <Modal
        width={1300}
        title="주문하기"
        cancelText={"취소"}
        okText={"주문하기"}
        closable={false}
        visible={this.props.modalOpen}
        onCancel={this.props.modalClose}
        onClick={totalMoney}
        onOk={()=>{
          if (orAddr === '' || orAddrDetail === '' || orZipCd === '') {
            notification.warning({placement: 'bottomLeft', message: `배송지를 확인해주세요.`, duration: 2});
            return false;
          }
          if (mgrUserId === '' || mgrHp === '') {
            notification.warning({placement: 'bottomLeft', message: `인수자 정보를 확인해주세요.`, duration: 2});
            return false;
          }
          // 결제 방법 미선택시 주문 못하게
          //추가
          if (mgrUserId === '' || payment === '') {
            notification.warning({placement: 'bottomLeft', message: `결제방법을 확인해주세요.`, duration: 2});
            return false;
          } 
          // console.log("this.props.ceType", this.props.ceType);
          if (window.confirm(`주문하기 이후에 주문내역은 수정이 불가합니다. 주문 하시겠습니까? `)) {
            if(payment === 'default'){
            //원래 주문
              this.props.addOrderList(
                orAddr,
                orAddrDetail, 
                orZipCd, 
                mgrUserId, 
                mgrHp,
                payment,
                deliveryPrice,
                "2" // 주문완료 
              );              
            }else{
              onClick(); //로지텍 전자결제
            }
          }
        }}
      >
        
        <div className="order_modal_p">
          <table className="table_st_wrap">
            <tbody>
              <tr>
                <th rowSpan="2">배송지</th>
                <td>
                  <Button 
                    type="primary"
                    onClick={()=>this.setState({modalOpenAddr: true})}
                  >우편번호 검색</Button>
                  <p>
                    <b>우편번호</b>
                    <span className="prog_input" style={{ width: '100px' }}>{orZipCd}</span>
                    <b>주소</b>
                    <span className="prog_input">{orAddr}</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p><b>상세주소</b></p>
                  <Input
                    style={{ width: '50%' }}
                    value={orAddrDetail}
                    onChange={(e)=>this.setState({orAddrDetail: e.target.value })}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <table className="table_st_wrap">
            <tbody>
              <tr>
                <th>인수자</th>
                <td>
                  <Input
                    style={{ width: '50%' }}
                    value={mgrUserId}
                    onChange={(e)=>this.setState({mgrUserId: e.target.value })}
                  />
                </td>
              </tr>
              <tr>
                <th>연락처</th>
                <td>
                  <Input
                    style={{ width: '50%' }}
                    value={mgrHp}
                    onChange={(e)=>this.setState({mgrHp: e.target.value })}
                  />
                </td>
              </tr>

              <tr>
                <th>결제 방법</th>
                <td>
                  <Descriptions.Item label="결제 *" span={1}>
                    <Radio.Group
                      onChange={(e)=>this.setState({payment: e.target.value })}
                      value={payment}
                  >
                      <Radio value={'100000000000'}><b>신용카드</b></Radio>
                      <Radio value={'001000000000'}><b>가상계좌</b></Radio>
                      <Radio value={'default'}><b>계산서</b></Radio>
                      <b style={radioTemp}>※ 주문수량이 10벌 이하이면 배송비 3,600원이 포함됩니다.</b>
                    </Radio.Group>
                  </Descriptions.Item>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="order_p_total">
          <div>총 <span className="num"> {this.props.cartList.length}</span>건 </div>
          <div>총 주문액 <span className="num">{totalMoney()}</span>원</div>
        </div>
        

        <Table 
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={this.props.cartList}
          pagination={false}
          scroll={{ x: 1200, y: 300 }}
        />
        <div className="last_chk_text02">
          <b>주문 하시겠습니까?</b>
          <br />
          (단, 주문 이후에 주문내역은 수정이 불가합니다.)          
          
        </div>

        <AddrSearch
          modalOpen={modalOpenAddr}
          modalClose={()=>this.setState({modalOpenAddr: false})}
          setAddrInfo={(data)=>{
            this.setState({ orAddr: data.addr, orZipCd: data.orZipCd });
          }}
        />

        
      </Modal>

      
    );
  }
}

export default withRouter(OrderModalNoUser);

